/**
 * Created by Administrador on 06/05/2019.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('passengerListService',passengerListService);

    passengerListService.$inject = ['$http', 'CONFIG','messageService'];

    function passengerListService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/report-passenger-list';

        var service = {
            getGeneralReportByFlight: getGeneralReportByFlight,
            getGeneralReportByFlightPdf: getGeneralReportByFlightPdf,
            getGeneralReportByDeparture: getGeneralReportByDeparture,
            getCountPassengersType: getCountPassengersType,
            updateFlightPassengerTypes: updateFlightPassengerTypes
        };

        return service;

        function getGeneralReportByFlight(status, flightId, detail){
            return $http.get(urlBase + '/flight?' + status + 'flightId=' + flightId+'&detail='+detail )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getGeneralReportByFlightPdf(status, flightId, detail){
            return $http.get(urlBase + '/flight/pdf?' + status + 'flightId=' + flightId+'&detail='+detail )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getGeneralReportByDeparture(status, departureFlightId, detail){
            return $http.get(urlBase + '/departure?' + status + 'departureFlightId=' + departureFlightId+'&detail='+detail )
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getCountPassengersType(passengers) {
            var contAdult = 0;
            var contChild = 0;
            var contInfant = 0;

            angular.forEach(passengers, function (passenger) {
                if (passenger.typeParent === 'adult') {
                    contAdult++;
                }

                if (passenger.typeParent === 'child') {
                    contChild++;
                }

                if (passenger.typeParent === 'infant') {
                    contInfant++;
                }
            });

            return {
                nAdult: contAdult,
                nChild: contChild,
                nInfant: contInfant
            };
        }

        function getFlightType(flights, type) {
            var flight = null;
            for (var i = 0; i < flights.length; i++) {
                if (flights[i] !== null && flights[i].returned === type) {
                    flight = flights[i];
                    break;
                }
            }
            return flight;
        }

        function updateFlightPassengerTypes(pnr, passengerTypes) {
            const flightIda = getFlightType(pnr.flights, false);
            const flightReturn = getFlightType(pnr.flights, true);
            if (pnr.roundTrip) {
                flightIda.nAdult = passengerTypes.nAdult;
                flightIda.nChild = passengerTypes.nChild;
                flightIda.nInfant = passengerTypes.nInfant;
                flightReturn.nAdult = passengerTypes.nAdult;
                flightReturn.nChild = passengerTypes.nChild;
                flightReturn.nInfant = passengerTypes.nInfant;
            } else {
                flightIda.nAdult = passengerTypes.nAdult;
                flightIda.nChild = passengerTypes.nChild;
                flightIda.nInfant = passengerTypes.nInfant;
            }
        }
    }
})();
